module.exports = ".product-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  min-height: 260px;\n  margin-top: 25px; }\n  .product-header atn-image-input,\n  .product-header atn-file-input {\n    margin-right: 20px; }\n  .product-header mat-form-field {\n    width: 180px; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/products/product-header-form/product-header-form.component.scss
// module id = ./libs/atenea-cms-brand/src/products/product-header-form/product-header-form.component.scss
// module chunks = main